import { catchRestError, RestClient } from "clients/rest";
import { UseFormReturn } from "react-hook-form";
import { PageableResponse } from "../PageableResponse";

export type B000130FindRequest = Partial<{
  eigyoCd: string;
  bumonCdFrom: string;
  bumonCdTo: string;
  name: string;
  // 削除予定区分チェック除外区分
  deljogaiKbn: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B000130FindResponse = {
  bumonCd: string;
  bumonNm: string;
  bumonNmr: string;
  bumonKana: string;
  telNo: string;
  faxNo: string;
  eigyoCd: string;
  sakujoyoteiKbn: number;
  eigyoNm: string;
  version: string;
};

export const B000130Find = (props: B000130FindRequest) => {
  return RestClient.get<PageableResponse<B000130FindResponse>>("b000130/find", {
    params: props,
  });
};

export type B000130GetRequest = {
  bumonCd: string;
};

export const B000130Get = (props: B000130GetRequest) => {
  return RestClient.get("b000130/get", {
    params: props,
  });
};

//部門名略取得メソッド
export const B000130BumonNmr = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.bumonCd === "") {
    methods.setValue("bumonNmr", data.bumonCd);
    return;
  }
  await B000130Get({ bumonCd: data.bumonCd })
    .then((response) => {
      methods.setValue("bumonNmr", response.data.bumonNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("bumonNmr", "");
    });
};

//部門名取得メソッド
export const B000130BumonNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.bumonCd === "") {
    methods.setValue("bumonNm", data.bumonCd);
    return;
  }
  await B000130Get({ bumonCd: data.bumonCd })
    .then((response) => {
      methods.setValue("bumonNm", response.data.bumonNm ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("bumonNm", "");
    });
};

//部門名(開始)取得メソッド
export const B000130BumonNmFrom = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.bumonCdFrom === "") {
    methods.setValue("bumonNmFrom", data.bumonCdFrom);
    return;
  }
  await B000130Get({ bumonCd: data.bumonCdFrom })
    .then((response) => {
      methods.setValue("bumonNmFrom", response.data.bumonNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("bumonNmFrom", "");
    });
};

//部門名(終了)取得メソッド
export const B000130BumonNmTo = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.bumonCdTo === "") {
    methods.setValue("bumonNmTo", data.bumonCdTo);
    return;
  }
  await B000130Get({ bumonCd: data.bumonCdTo })
    .then((response) => {
      methods.setValue("bumonNmTo", response.data.bumonNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("bumonNmTo", "");
    });
};

//部門名(開始)取得メソッド(セットするのはbumonNmrFrom)
export const B000130BumonNmrFrom = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.bumonCdFrom === "") {
    methods.setValue("bumonNmrFrom", data.bumonCdFrom);
    return;
  }
  await B000130Get({ bumonCd: data.bumonCdFrom })
    .then((response) => {
      methods.setValue("bumonNmrFrom", response.data.bumonNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("bumonNmrFrom", "");
    });
};

//部門名(終了)取得メソッド(セットするのはbumonNmrTo)
export const B000130BumonNmrTo = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.bumonCdTo === "") {
    methods.setValue("bumonNmrTo", data.bumonCdTo);
    return;
  }
  await B000130Get({ bumonCd: data.bumonCdTo })
    .then((response) => {
      methods.setValue("bumonNmrTo", response.data.bumonNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("bumonNmrTo", "");
    });
};

//売掛担当部門名取得メソッド
export const B000130UrikakebumonNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.urikakebumonCd === "") {
    methods.setValue("urikakebumonNm", data.urikakebumonCd);
    return;
  }
  await B000130Get({ bumonCd: data.urikakebumonCd })
    .then((response) => {
      methods.setValue("urikakebumonNm", response.data.bumonNm ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("urikakebumonNm", "");
    });
};
